import React from "react";
import PropTypes from "prop-types";
import { Link } from "gatsby";
import styled from "styled-components";
import { _ } from "../utils/i18n";

import SectionHead from "../components/section-head";
import FilterButtonGroup from "../components/filter-button-group";
import FilterButton from "../components/filter-button";
import ImageLibpixel from "./image-libpixel.js";

const Tags = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-between;
  @media (max-width: 810px) {
    padding: 0 20px;
  }
`;
const TopTitle = styled.h3`
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  font-size: 2.1rem;
  line-height: 40px;
  width: 100%;
  @media (max-width: 810px) {
    font-size: 1.4rem;
    font-weight: 200;
  }
`;
const FilterBox = styled.div`
  display: flex;
  flex-direction: column;
  @media (max-width: 810px) {
    width: 65%;
  }
`;
const CaseTitle = styled.h4`
  font-size: 1.1rem;
  @media (max-width: 810px) {
    font-size: 0.9rem;
  }
`;
const DateBox = styled.div`
  display: flex;
  flex-direction: column;
  @media (max-width: 810px) {
    width: 35%;
  }
`;
const CaseDate = styled.p`
  font-size: 1rem;
  @media (max-width: 810px) {
    font-size: 0.8rem;
  }
`;
const ImgContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin-bottom: 20px;
`;
const Img = styled(ImageLibpixel)`
  width: 100%;
  height: 600px;
  object-fit: cover;
  margin-top: 40px;
  @media (max-width: 810px) {
    height: 450px;
    margin-top: 20px;
    padding: 0 20px;
    padding: 0;
  }
`;
const CaseHeader = ({ dateFrom, dateTo, post, title }) => {
  return (
    <div>
      <SectionHead
        title={post.title.replace("&#038;", "&").replace("&amp;", "&")}
      />
      <Tags>
        <TopTitle>{title}</TopTitle>
        <FilterBox>
          <CaseTitle>{_("Tjenster benyttet")}:</CaseTitle>
          <FilterButtonGroup innerStyle={{ padding: 0 }}>
            {post?.categories.nodes?.map((c, i) => (
              <Link
                key={i}
                to={c.uri.replace("/category", "")}
                className="no-underline"
              >
                <FilterButton label={c.name} variant="outlined" size="small" />
              </Link>
            ))}
          </FilterButtonGroup>
        </FilterBox>
        <DateBox>
          <CaseTitle>{_("Periode")}:</CaseTitle>
          <CaseDate>
            {dateFrom} - {dateTo}
          </CaseDate>
        </DateBox>
      </Tags>
      <ImgContainer>
        <Img
          src={post.featuredImage?.node?.sourceUrl}
          alt={post.featuredImage?.node?.altText}
          style={{ marginTop: 0 }}
        />
      </ImgContainer>
    </div>
  );
};

CaseHeader.propTypes = {
  dateFrom: PropTypes.string,
  dateTo: PropTypes.string,
  post: PropTypes.object,
  title: PropTypes.string,
};

CaseHeader.defaultProps = {
  dateFrom: undefined,
  dateTo: undefined,
  post: undefined,
  title: undefined,
};

export default CaseHeader;
